import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import { useAuth } from '@clerk/clerk-react';

export const GET_PDF_PAGE_STATUS_QUERY_KEY = 'get-pdf-page-status';

export interface PdfPageStatusDto {
  page: number;
  totalPages?: number;
}

export const useGetPdfPageStatusQuery = (entityRef: string | undefined, options?: { enabled?: boolean }) => {
  const { getToken } = useAuth();
  const enabled = !!entityRef && (options?.enabled ?? true);

  return useQuery({
    queryKey: [GET_PDF_PAGE_STATUS_QUERY_KEY, entityRef],
    queryFn: async () => {
      const token = await getToken();
      return getPdfPageStatus({ token: token ?? '', entityRef: entityRef! });
    },
    enabled,
  });
};

const getPdfPageStatus = async ({
  token,
  entityRef,
}: {
  token: string;
  entityRef: string;
}): Promise<PdfPageStatusDto | null> => {
  const url = `${import.meta.env.VITE_API_URL}/player/pdf-page-status?entityRef=${encodeURIComponent(entityRef)}`;
  const data = await sendJSONRequest({ url, method: METHOD.GET, token });
  return (data ?? null) as PdfPageStatusDto | null;
};
